export const convertToWebSocketUrl = (baseUrl: string, path = ""): string => {
  try {
    const url = new URL(baseUrl);
    url.protocol = url.protocol === "https:" ? "wss:" : "ws:";

    return `${url.toString()}${path}`.replace(/([^:]\/)\/+/g, "$1");
  } catch (error) {
    console.error("Invalid URL:", error);
    return baseUrl;
  }
};
